var _line, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgGlobalSearchIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 2.18557e-8,
    x2: 0.499999,
    y2: 25,
    stroke: "#CED0DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6649 15.1359C20.561 14.0156 21.0969 12.5946 21.0969 11.0484C21.0969 7.43183 18.165 4.5 14.5484 4.5C10.9318 4.5 8 7.43183 8 11.0484C8 14.665 10.9318 17.5969 14.5484 17.5969C16.0946 17.5969 17.5156 17.061 18.6359 16.1649L22.7579 20.2869C23.042 20.571 23.5027 20.571 23.7869 20.2869C24.071 20.0027 24.071 19.542 23.7869 19.2579L19.6649 15.1359ZM14.5484 16.1489C11.7315 16.1489 9.4479 13.8654 9.4479 11.0484C9.4479 8.23149 11.7315 5.9479 14.5484 5.9479C17.3654 5.9479 19.6489 8.23149 19.6489 11.0484C19.6489 13.8654 17.3654 16.1489 14.5484 16.1489Z",
    fill: "#3C3ADA"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGlobalSearchIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/GlobalSearchIcon.e373c47f.svg";
export { ForwardRef as ReactComponent };